const LOGO_COUNT = 8;
const LOGO_PATHS = Array.from({ length: LOGO_COUNT }, (_, i) => `/logo${i + 1}.png`);

const LogoCarousel = () => {
  return (
    <section className="py-12 min-h-[180px] bg-white overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="relative min-h-[72px]">
          {/* 横スクロール用ラッパー */}
          <div className="flex gap-12 md:gap-16 items-center logo-carousel-track">
            {LOGO_PATHS.map((src, i) => (
              <div
                key={src}
                className="flex-shrink-0 flex items-center justify-center w-32 h-16 md:w-40 md:h-20 opacity-90 hover:opacity-100 transition-opacity"
              >
                <img
                  src={src}
                  alt=""
                  className="max-h-full w-auto object-contain"
                  loading="lazy"
                />
              </div>
            ))}
            {/* ループ用に同じセットを2回並べる */}
            {LOGO_PATHS.map((src) => (
              <div
                key={`dup-${src}`}
                className="flex-shrink-0 flex items-center justify-center w-32 h-16 md:w-40 md:h-20 opacity-90"
              >
                <img
                  src={src}
                  alt=""
                  className="max-h-full w-auto object-contain"
                  loading="lazy"
                />
              </div>
            ))}
          </div>
        </div>
      </div>
      <style>{`
        .logo-carousel-track {
          animation: logoScroll 18s linear infinite;
        }
        .logo-carousel-track:hover {
          animation-play-state: paused;
        }
        @keyframes logoScroll {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
      `}</style>
    </section>
  );
};

export default LogoCarousel;
